import { useState } from 'react';

export default function AppStoreButton({ href = "https://apps.apple.com/app/turfx/id6798533280", style = {} }) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '12px',
        backgroundColor: '#000000',
        backgroundImage: 'linear-gradient(180deg, #161616 0%, #000000 100%)',
        color: '#FFFFFF',
        padding: '9px 20px',
        borderRadius: '12px',
        textDecoration: 'none',
        border: isHovered ? '1.5px solid rgba(255, 255, 255, 0.45)' : '1.5px solid rgba(255, 255, 255, 0.2)',
        boxShadow: isHovered 
          ? '0 10px 28px rgba(0, 0, 0, 0.6), 0 0 20px rgba(0, 122, 255, 0.25)' 
          : '0 6px 20px rgba(0, 0, 0, 0.4)',
        transform: isHovered ? 'translateY(-2px) scale(1.02)' : 'translateY(0) scale(1)',
        transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
        cursor: 'pointer',
        userSelect: 'none',
        maxWidth: 'fit-content',
        ...style
      }}
    >
      {/* Official Apple Logo SVG Icon */}
      <svg 
        width="26" 
        height="26" 
        viewBox="0 0 384 512" 
        fill="#FFFFFF" 
        xmlns="http://www.w3.org/2000/svg"
        style={{ flexShrink: 0 }}
      >
        <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 52.3-14.1 69.5-34.3z"/>
      </svg>

      {/* Button Text */}
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', textAlign: 'left', lineHeight: 1 }}>
        <span style={{ 
          fontSize: '0.62rem', 
          fontWeight: '700', 
          letterSpacing: '0.8px', 
          textTransform: 'uppercase', 
          color: '#9CA3AF',
          marginBottom: '3px'
        }}>
          Download on the
        </span>
        <span style={{ 
          fontSize: '1.05rem', 
          fontWeight: '700', 
          letterSpacing: '0.2px', 
          color: '#FFFFFF',
          fontFamily: "'Sora', -apple-system, Roboto, sans-serif"
        }}>
          App Store
        </span>
      </div>
    </a>
  );
}
